import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const putBusSimulate = ({ id, ...data }) => {
  return api.put(`/admin/buses-v2/simulate/${id}`, data);
};

export const putBusSimulateQueryOptions = data => {
  return queryOptions({
    queryKey: ["put-bus-simulate", data],
    queryFn: () => putBusSimulate(data),
  });
};

export const usePutBusSimulateQuery = ({ queryConfig = {}, ...data }) => {
  return useQuery({
    ...putBusSimulateQueryOptions(data),
    ...queryConfig,
  });
};
